exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._7hqmMFd8M_1xE835w09GR {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin: 0 36px;\n  height: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"centerSlot": "_7hqmMFd8M_1xE835w09GR"
};